export default __webpack_public_path__ + "static/media/ust.b94a6d95.png";